import { apiSlice } from "../../app/api/apiSlice"
import { logOut, setCredentials } from "./authSlice"

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: credentials => ({
                url: '/auth',
                method: 'POST',
                body: { ...credentials }
            })
        }),
        googleLogin: builder.mutation({
            query: ({ credential }) => ({
                url: '/auth/google',
                method: 'POST',
                body: { credential }
            })
        }),
        sendLogout: builder.mutation({
            query: () => ({
                url: '/auth/logout',
                method: 'POST',
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    console.log(data)
                    dispatch(logOut())
                    setTimeout(() => {
                        dispatch(apiSlice.util.resetApiState())
                    }, 1000)
                } catch (err) {
                    console.log(err)
                }
            }
        }),
        refresh: builder.mutation({
            query: () => ({
                url: '/auth/refresh',
                method: 'GET',
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    console.log(data)
                    const { accessToken } = data
                    dispatch(setCredentials({ accessToken }))
                } catch (err) {
                    console.log(err)
                }
            }
        }),
        resetPasswordRequest: builder.mutation({
            query: ({ email }) => ({
                url: '/auth/reset-password-request',
                method: 'POST',
                body: { email }
            })
        }),
        resetPasswordConfirm: builder.mutation({
            query: ({ token, email, newPassword }) => ({
                url: '/auth/reset-password-confirm',
                method: 'POST',
                body: { token, email, newPassword }
            })
        }),
    })
})

export const {
    useLoginMutation,
    useGoogleLoginMutation,
    useSendLogoutMutation,
    useRefreshMutation,
    useResetPasswordRequestMutation,
    useResetPasswordConfirmMutation,
} = authApiSlice